export const getDataFromSelector = (state, dataKey) => {
    const pendingKey = `${dataKey}Pending`;
    return {
        data: state[dataKey],
        pending: state[pendingKey],
    };
};